/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { BuyInsurancePageService } from '@pages/BuyInsurancePage/services';
import { logger as log } from '@common/logger';

const MODULE_NAME = 'profile.machines.states.resend';

const getSrv = () => {
  return vappContainer.get<BuyInsurancePageService>(
    BuyInsurancePageService.displayName
  );
};

export const getKYCFormData = async (context: any, event: any) => {
  const currentState = 'GET_KYC_FORM_DATA';
  const method = 'getKYCFormData';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const _formData = await srv?.agent?.getKYCFormDataContent();
      console.log('kyc form data', _formData);
      if (_formData) {
        return resolve({
          key: 'USER_LOGIN_SUCCESS',
          value: {
            ...(_formData || {}),
          },
        });
      } else {
        const msg = 'Form content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'USER_LOGIN_SUCCESS',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'USER_LOGIN_SUCCESS',
        value: err?.message,
      });
    }
  });
};
